import request from '../request/request';

export default (email: string): Promise<any> =>
  request('POST', '/v1.0/reset-password-request', { email });
